import React, { useEffect, useState } from "react";
import { fetchSharedNotes, addComment } from "../api/api";
import "./NotesPage.css"; // Import the stylesheet
// import { useLocation } from "react-router-dom";

function SharedNotesPage({ token }) {
  const [notes, setNotes] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split("T")[0]); // Default to today's date
  const [commentInputs, setCommentInputs] = useState({}); // State for comment inputs for each note

  // const location = useLocation(); // Get current path

  const loadNotes = async () => {
    const notes = await fetchSharedNotes(selectedDate, token); // Fetch notes for the selected date
    setNotes(notes);

  };

  useEffect(() => {
    
    loadNotes();
  }, [selectedDate, token]);

  const handleDateChange = (direction) => {
    const currentDate = new Date(selectedDate);
    const newDate = new Date(
      currentDate.setDate(currentDate.getDate() + (direction === "next" ? 1 : -1))
    )
      .toISOString()
      .split("T")[0];
    setSelectedDate(newDate);
  };

  const handleCommentChange = (note_id, value) => {
    setCommentInputs((prev) => ({ ...prev, [note_id]: value }));
  };

  const handleAddComment = async (note_id) => {
    const comment = commentInputs[note_id];
    if (!comment) {
      alert("Please enter a comment.");
      return;
    }

    await addComment(note_id, selectedDate, comment, token); // Call the API to add the comment
    setCommentInputs((prev) => ({ ...prev, [note_id]: "" })); // Clear the comment input for that note

    const updatedNotes = await fetchSharedNotes(selectedDate, token); // Fetch notes for the selected date
    setNotes(updatedNotes);
  };

  return (
    <div className="notes-container">
      
      <div className="page-title">Notes Shared with Me</div>
      {/* Date Selector */}
      <div className="date-selector">
        <button className="date-arrow" onClick={() => handleDateChange("prev")}>
          &#8592;
        </button>
        <div className="date-display">{selectedDate}</div>
        <button className="date-arrow" onClick={() => handleDateChange("next")}>
          &#8594;
        </button>
      </div>

      {/* Input Section */}
      {/* <h2>Shared Notes for {selectedDate}</h2> */}
      <ul className="notes-list">
        {notes.map((note) => (
          <li key={note.note_id} className="note-item">
            <div className="note-shared-by">{note.shared_by}</div>
            <div className="shared-note-content">{note.content}</div>
            <div className="note-shared-with">Shared with: {note.shared_with.join(", ")}</div>
            {/* Comments Section */}
            <div className="comments-section">
              <h3>Comments</h3>
              {note.comments && note.comments.length > 0 ? (
                <ul className="comments-list">
                  {note.comments.map((comment, index) => (
                    <li key={index} className="comment-item">
                      <span className="comment-author">{comment.commenter}:</span> {comment.comment}
                    </li>
                  ))}
                </ul>
              ) : (
                <p>No comments yet. Be the first to comment!</p>
              )}
              <textarea
                className="comment-input"
                placeholder="Add a comment..."
                value={commentInputs[note.note_id] || ""}
                onChange={(e) => handleCommentChange(note.note_id, e.target.value)}
              />
              <button
                className="add-comment-button"
                onClick={() => handleAddComment(note.note_id)}
              >
                Add Comment
              </button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default SharedNotesPage;
